export default function PHP_Create_Arrays() {
  return (
    <div>
      <h1>PHP_Create_Arrays</h1>
    </div>
  );
}
